import { BarChart, BarChartProps } from '@mantine/charts';

import OverlayedBarLegend from '../overlayed-bar-legend/overlayed-bar-legend';

import { OverlayedBarChartTooltip } from './tooltip';

interface OverlayedBarChartProps {
  data: BarChartProps['data'];
  olympicValue?: number;
  referenceValue?: number;
  olympicLabel?:string;
  referenceLabel?: string;
  baselineDataKey: string;
  actualDataKey: string;
  title: React.ReactNode;
  actualDataColor?: string;
}

export function OverlayedBarChart({
  data,
  olympicValue,
  referenceValue,
  baselineDataKey,
  actualDataKey,
  title,
  olympicLabel,
  referenceLabel,
  actualDataColor,
}: OverlayedBarChartProps) {
  return (
    <BarChart
      barChartProps={{ barGap: -52 }}
      barProps={(series) => {
        if (series.name === baselineDataKey) {
          return {
            barSize: 60,
          };
        }
        if (series.name === actualDataKey) {
          return {
            barSize: 45,
          };
        }
        return {};
      }}
      data={data}
      dataKey="name"
      h={350}
      legendProps={{
        verticalAlign: 'bottom',
        content: (
          <OverlayedBarLegend
            olympicLabel={olympicLabel}
            referenceLabel={referenceLabel}
            title={title}
            withOlympic={!!olympicValue}
            withReference={!!referenceValue}
          />
        ),
      }}
      referenceLines={[
        ...(referenceValue ? [{ stroke: 'red', strokeWidth: 3, y: referenceValue }] : []),
        ...(olympicValue ? [{ stroke: 'blue', strokeWidth: 3,  strokeDasharray: '10, 10', y: olympicValue }] : [])
      ]}
      series={[
        { name: baselineDataKey, color: '#D9D9D9' },
        { name: actualDataKey, color: actualDataColor ?? '#E2C949' },
      ]}
      tooltipProps={{
        content: ({ label, payload }) => (
          <OverlayedBarChartTooltip label={label} payload={payload} />
        ),
      }}
      withLegend
    />
  );
}

export default OverlayedBarChart;
